import { LitElement, html, css } from 'lit';
import { ProgressBar } from './progress-bar.js';
export class CollectionProgressBar extends LitElement {
	static styles = [
		css`
			:host {
				display: block;
			}
		`,
	];

	static properties = {
		total: { type: Number },
		current: { type: Number },
	};

	connectedCallback() {
		super.connectedCallback();
	}

	render() {
		return html`
			<progress-bar
				value=${Math.round((this.current / this.total) * 100)}
			></progress-bar>
		`;
	}
}
if (!customElements.get('collection-progress-bar'))
	customElements.define('collection-progress-bar', CollectionProgressBar);
